import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "../../app/store";
import { UserPreviewInfo } from "../../components/essentials/user-card/UserCard";
import { IMessage } from "../../scenes/messages/components/message/Message";
import { ChatApiRoutes } from "../../shared/api-routes/chat.api-routes";
import http from "../../shared/utils/http";

type ActiveChatInfo = {
	chatId: string | null;
	other: UserPreviewInfo | undefined;
	messages: IMessage[];
};
export interface ChatInfo {
	id: string;
	lastMessage: IMessage;
	other: UserPreviewInfo;
}

type ChatState = {
	activeChat: ActiveChatInfo;
	chats: ChatInfo[];
};

const initialState: ChatState = {
	activeChat: { chatId: null, messages: [], other: undefined },
	chats: [],
};

export const activateChat =
	(chatId: string): AppThunk =>
	async (dispatch) => {
		dispatch(setActiveChat(chatId));
		const response = await http.get(ChatApiRoutes.GET_MESSAGES_IN_CHAT(chatId));
		dispatch(setMessages(response));
	};

const messagesSlice = createSlice({
	name: "chat",
	initialState,

	reducers: {
		setActiveChat(state, action: PayloadAction<string | null>) {
			state.activeChat.chatId = action.payload;
		},

		setChats(state, action: PayloadAction<ChatInfo[]>) {
			console.log(action.payload);
			state.chats = action.payload;
		},

		addNewChat(state, action: PayloadAction<ChatInfo>) {
			const existingChat = state.chats.find(
				(chat) => chat.id === action.payload.id
			);
			if (!existingChat) {
				state.chats.unshift(action.payload);
			}
		},

		setMessages(state, action: PayloadAction<IMessage[]>) {
			const messages = action.payload;
			state.activeChat.messages = messages;
			const chat = state.chats.find(
				(chat) => chat.id === state.activeChat.chatId
			);

			if (chat && chat.lastMessage) {
				chat.lastMessage.read = true;
			}
		},

		setActiveOther(state, action: PayloadAction<UserPreviewInfo>) {
			const other = action.payload;

			state.activeChat.other = other;
		},

		addMessage(
			state,
			action: PayloadAction<{ chatId: string; message: IMessage }>
		) {
			const { chatId, message } = action.payload;

			if (state.activeChat.chatId === chatId) {
				state.activeChat.messages.unshift(message);
			}

			const chat = state.chats.find((chat) => chat.id === chatId);

			if (chat) {
				chat.lastMessage = message;
				if (chatId === state.activeChat.chatId) {
					chat.lastMessage.read = true;
				} else {
					chat.lastMessage.read = false;
				}
			}
		},

		editMessage(state, action: PayloadAction<IMessage>) {
			const newMessage = action.payload;
			state.activeChat.messages = state.activeChat.messages.map((message) => {
				return message.id === newMessage.id ? newMessage : message;
			});
		},

		editLastMessage(state, action: PayloadAction<IMessage>) {
			const newMessage = action.payload;
			const chat = state.chats.find((chat) => chat.id === newMessage.chatId);
			if (chat) {
				chat.lastMessage = newMessage;
			}
		},

		removeMessage(state, action: PayloadAction<string>) {
			const messageIdToRemove = action.payload;
			console.log(JSON.parse(JSON.stringify(state.activeChat.messages)));
			state.activeChat.messages = state.activeChat.messages.filter(
				(msg) => msg.id !== messageIdToRemove
			);
		},

		removeLastMessage(
			state,
			action: PayloadAction<{ chatId: string; messageId: string }>
		) {
			const chat = state.chats.find(
				(chat) => chat.id === action.payload.chatId
			);
			if (chat) {
				chat.lastMessage.text = "[message deleted]"; // to refactor
			}
		},

		readMessagesInChat(
			state,
			action: PayloadAction<{ chatId: string; memberId: string }>
		) {
			state.activeChat.messages.map((msg) => {
				console.log(msg);
				return { ...msg, read: true };
			});
		},
	},
});

export const {
	addMessage,
	addNewChat,
	setChats,
	setActiveChat,
	setActiveOther,
	setMessages,
	editMessage,
	editLastMessage,
	removeMessage,
	removeLastMessage,
	readMessagesInChat,
} = messagesSlice.actions;

export const selectMessages = (state: RootState) => state.messages;

export const selectUnreadCount = (state: RootState) =>
	state.messages.chats.filter((chat) => chat.lastMessage && !chat.lastMessage.read).length;

export default messagesSlice.reducer;
